export default __webpack_public_path__ + "static/media/coingecko.4bc28e65.webp";